import { Link } from "react-router-dom";
import { Box, IconButton } from "@mui/material";

import APP_ROUTES from "../../../../routers/routeConstants";

import { GoalngoMobileLogo, ShowSideNavButtonIcon } from "../../assets/icons/layout-icons";

const MobileNavBar = ({ onOpenMobileNav }: { onOpenMobileNav?: () => void }) => {
  return (
    <Box sx={styles.container}>
      <Box component={Link} to={APP_ROUTES.DASHBOARD}>
        <GoalngoMobileLogo />
      </Box>
      <IconButton aria-label="open navigation" onClick={onOpenMobileNav}>
        <ShowSideNavButtonIcon />
      </IconButton>
    </Box>
  );
};

export default MobileNavBar;

const styles = {
  container: {
    px: "16px",
    flex: 1,
    display: { xs: "flex", lg: "none" },
    justifyContent: "space-between",
  },
};
